/**
 * Payment Method schemas (payments-manager plugin)
 */
import { z } from "zod";
import { NestedPaginationParamsSchema, PaymentMethodDetailsSchema, SortParamsSchema, StrapiIdSchema, } from "./common.schemas";
import { LazyUserRelation, PaymentMethodRelationSchema } from "./relations";
// ============================================================================
// Enums
// ============================================================================
/**
 * Payment method type schema
 */
export const PaymentMethodTypeSchema = z.enum(["card"]);
// PaymentProcessorSchema is in common.schemas.ts
// ============================================================================
// Input Schemas
// ============================================================================
/**
 * Payment method query params schema
 */
export const PaymentMethodQueryParamsSchema = NestedPaginationParamsSchema.merge(SortParamsSchema)
    .extend({
    filters: z
        .object({
        pm_owner: z
            .object({
            id: z.object({ $eq: StrapiIdSchema.optional() }).strict().optional(),
        })
            .strict()
            .optional(),
        pm_isValid: z.object({ $eq: z.boolean().optional() }).strict().optional(),
        pm_type: z.object({ $eq: PaymentMethodTypeSchema.optional() }).strict().optional(),
    })
        .strict()
        .optional(),
})
    .strict();
// ============================================================================
// Entity Schemas
// ============================================================================
// PaymentMethodDetailsSchema is imported from common.schemas.ts
/**
 * Payment method schema - extends PaymentMethodRelationSchema with typed details and relations
 */
export const PaymentMethodSchema = PaymentMethodRelationSchema.extend({
    // Override with typed details schema
    pm_details: PaymentMethodDetailsSchema.nullish(),
    // Relations
    pm_owner: LazyUserRelation.nullish(),
});
